import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import { BelongsTo, Review, Store } from '../../../reviews/types';

import * as S from './styles';
import { IconEdit } from '@prisjakt/ui/icon';

const CURRENT_YEAR = new Date().getFullYear();

type OwnProps = {
  belongsTo: BelongsTo;
  myReview?: Review;
  store: Store;
  year?: number;
};

const SotyPromo = ({
  belongsTo,
  myReview,
  store,
  year = CURRENT_YEAR,
}: OwnProps) => {
  const { t, market } = useContext(AppContext);

  const cdnDir = `${market.cdn}/g/store_of_the_year/${year}/${market.code}`;
  const badgeURI = `${cdnDir}/award/main_award.png`;
  const altText = t('campaigns', 'shop-of-the-year.title-with-year', {
    year,
  });

  return (
    <S.SotyPromo>
      <S.Badge>
        <img src={badgeURI} alt={altText} title={altText} />
      </S.Badge>
      <S.Title>{t('campaigns', 'shop-of-the-year.shop-promo-title')}</S.Title>
      <S.Description>
        {t('campaigns', 'shop-of-the-year.shop-promo-description', { year })}
      </S.Description>
      <S.UserReviewPrompt
        belongsTo={belongsTo}
        store={store}
        currentReview={myReview}
        control={
          <S.PromptButton
            color="primary"
            iconPosition="left"
            icon={<IconEdit size={18} />}
          >
            {t('reviews', 'button.write-review')}
          </S.PromptButton>
        }
      />
    </S.SotyPromo>
  );
};

export default SotyPromo;
